import { ComponentType } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { errors } from '@ocean/ui'
import { SessionUtils } from '@ocean/utils'
import authRoutes from 'modules/Auth/routing/routes'
import homeRoutes from 'modules/Home/routing/routes'

const { AccessDenied } = errors

type PrivateRouteProps = {
  path?: string | string[]
  component: ComponentType<any>
  exact?: boolean
  disabled?: boolean
}

const PrivateRoute: React.FC<PrivateRouteProps> = props => {
  const { path, component: ProtectedComponent, disabled, exact } = props
  const isSessionExists = !!SessionUtils.getSessionToken()

  function renderComponent(props: any) {
    if (!isSessionExists)
      return (
        <Redirect
          to={{
            pathname: authRoutes.login,
            state: { target: props.location },
          }}
        />
      )

    if (!disabled) return <ProtectedComponent {...props} />

    return <AccessDenied backUrl={homeRoutes.root} />
  }

  return <Route exact={exact} path={path} render={renderComponent} />
}

export default PrivateRoute
